// The maximum number of phrases to list before saying "and several more".
export const MAXIMUM_PHRASES = 3;
